import React, { useState, useEffect } from "react";

import Spain from "../../assets/spain.png";
import English from "../../assets/united-kingdom.png";

function Main({ setPhase }) {
  const [language, setLanguage] = useState("es");
  const [level, setLevel] = useState("easy");
  const [timer, setTimer] = useState("");

  useEffect(
    () => {
      let lang = localStorage.getItem("lang");
      let level = localStorage.getItem("level");

      if (lang !== null) setLanguage(lang);
      else localStorage.setItem("lang", "es");
      if (level !== null) setLevel(level);
      else localStorage.setItem("level", "easy");
    },
    [language, level]
  );

  const handleLanguage = lang => {
    setLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  const handleLevel = level => {
    setLevel(level);
    localStorage.setItem("level", level);
  };

  const handlePhase = phase => {
    setTimer(phase);
    setPhase(phase);
    localStorage.setItem("phase", phase);
  };

  let spain = language === "es" ? "idioma es selected" : "idioma es";
  let english = language === "en" ? "idioma en selected" : "idioma en";

  let easy = level === "easy" ? "btn lvl selected" : "btn lvl";
  let medium = level === "medium" ? "btn lvl selected" : "btn lvl";
  let hard = level === "hard" ? "btn lvl selected" : "btn lvl";

  return (
    <div className="container main-stage">
      <h1>Busca Palabras</h1>
      <div>
        <div className="idiomas">
          <button className={spain} onClick={() => handleLanguage("es")}>
            <img src={Spain} alt="spain" className="langPhoto" />
            <div className="langText">Español</div>
          </button>
          <button className={english} onClick={() => handleLanguage("en")}>
            <img src={English} alt="english" className="langPhoto" />
            <div className="langText">English</div>
          </button>
        </div>
        <div>
          <button className={easy} onClick={() => handleLevel("easy")}>
            <p>Fácil</p>
          </button>
          <button className={medium} onClick={() => handleLevel("medium")}>
            <p>Medio</p>
          </button>
          <button className={hard} onClick={() => handleLevel("hard")}>
            <p>Difícil</p>
          </button>
        </div>
        <button className="btn play" onClick={() => handlePhase("timer")}>
          <p>Siguiente</p>
        </button>
      </div>
    </div>
  );
}

export default Main;
